{
	"title": "Cronologia transazioni {{productName}}",
	"item": {
		"time": "Ora",
		"description": "Descrizione",
		"transactionId": "ID transazione",
		"showIds": "Mostra ID",
		"depositTitle": "Assicurazione DNV, che consente un deposito nella banca del carbonio",
		"depositDescription": "Una volta che l’organismo di assicurazione terzo 'DNV' ha verificato il volume di carbonio catturato stoccato in un sistema digitale Monitor-Report-Verify, viene effettuato un nuovo deposito nella banca del carbonio.",
		"withdrawalTitle": "Fattura al fornitore, che attiva un prelievo dalla banca del carbonio",
		"withdrawalDescription": "Con la fatturazione del materiale evoZero al fornitore, è stato eseguito un prelievo dalla banca del carbonio.",
		"transferTitle": "Trasferimento delle riduzioni di carbonio al titolare della dichiarazione",
		"transferDescription": "Il fornitore ha avviato il trasferimento delle riduzioni di carbonio al titolare della dichiarazione, in base al volume di materiale evoZero impiegato nel prodotto consegnato."
	},
	"proofIdsModal": {
		"titleTransactions": "Visualizza transazioni",
		"titleMeasurements": "Visualizza misurazioni",
		"paragraph1": "Un passaggio di transazione su {{productName}} prevede l’aggregazione delle transazioni sul registro distribuito. Di seguito trovi un elenco di link a servizi di terze parti dove puoi visualizzare queste transazioni.",
		"paragraph2": "Nota che questi link ti porteranno a siti web esterni che forniscono funzionalità di visualizzazione delle transazioni.",
		"open": "Apri",
		"close": "Chiudi"
	},
	"errors": {
		"fetch": "Impossibile recuperare la cronologia attività"
	}
}
